var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5767 0.375H0.860795C0.592498 0.375 0.375 0.592498 0.375 0.860795V10.5767C0.375 10.845 0.592498 11.0625 0.860795 11.0625H10.5767C10.845 11.0625 11.0625 10.845 11.0625 10.5767V0.860795C11.0625 0.592498 10.845 0.375 10.5767 0.375Z",
    fill: "#DF0000",
    stroke: "#DF0000",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/Stop.b4adac7313f7cd61aa11a3a936e4461a.svg";
export { ForwardRef as ReactComponent };